import { Main } from "./styled/Main";

export const UsuarioPageMainPresenter = ({ children }) => <Main>{children}</Main>
